import { Box, Container, FormGroup, Stack, TextField, Typography } from "@mui/material";
import {
  RedesignrCheckbox,
  RedesignrFormControlLabel,
  RedesignrFormControlLabelContent,
  WfButton,
} from "@WahooFitness/redesignr";
import { GlobalHeader, useConfigContext } from "@WahooFitness/wahoo-offline-mfe";
import { t, Trans } from "@lingui/macro";
import useRequestWearables, { MAX_PARAM_LENGTH, WEARABLES } from "./useRequestWearables";

function RequestWearables() {
  const { globalBottomPadding } = useConfigContext();
  const {
    selected,
    toggleWearable,
    otherWearable,
    handleOtherWearableChange,
    canSubmit,
    submit,
    cancel,
  } = useRequestWearables();

  return (
    <Container maxWidth="sm" disableGutters sx={{ minHeight: "100%" }}>
      <GlobalHeader title={t`Request wearables`} />
      <Box display="flex" flexDirection="column" gap={2} px={2} pt={1} pb={globalBottomPadding}>
        <Typography variant="prose-sm" color="text.secondary">
          <Trans>Which wearable would you like to connect?</Trans>
        </Typography>
        <FormGroup>
          <Stack gap={1.5}>
            {WEARABLES.map(({ id, name }) => (
              <RedesignrFormControlLabel
                key={id}
                value={id}
                data-testid={`request-wearables-option-${id}`}
                control={
                  <RedesignrCheckbox
                    checked={selected.includes(id)}
                    onChange={() => toggleWearable(id)}
                    name={name}
                  />
                }
                label={<RedesignrFormControlLabelContent align="left" label={name} />}
              />
            ))}
          </Stack>
        </FormGroup>
        <Typography variant="prose-xs" color="text.secondary" align="center">
          <Trans>Not seeing yours on the list?</Trans>
        </Typography>
        <TextField
          variant="outlined"
          fullWidth
          label={t`Wearable request`}
          placeholder={t`Enter wearable name`}
          value={otherWearable}
          onChange={handleOtherWearableChange}
          // Label floated so the placeholder shows before the field is focused, as designed.
          InputLabelProps={{ shrink: true }}
          inputProps={{
            maxLength: MAX_PARAM_LENGTH,
            "data-testid": "request-wearables-other-input",
          }}
        />
        <Stack gap={1}>
          <WfButton
            hierarchy="primary"
            size="large"
            fullWidth
            disabled={!canSubmit}
            onClick={submit}
            data-testid="request-wearables-submit-button"
          >
            <Trans>Submit</Trans>
          </WfButton>
          <WfButton
            hierarchy="tertiary"
            size="large"
            fullWidth
            onClick={cancel}
            data-testid="request-wearables-cancel-button"
          >
            <Trans>Cancel</Trans>
          </WfButton>
        </Stack>
      </Box>
    </Container>
  );
}

export default RequestWearables;
